import React, { Component } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as ROUTE from 'constants/appRouting'
import { updateUserLastApplicationUrl } from 'reducers/profile/reducer'
import withPromise from 'helpers/withPromise'
import { checkPathInApps } from 'helpers/apps-menu'
import Page404 from 'routes/Exception/routes/404'
import APPLICATIONS from './applications'
import SisenseDashboards from './SisenseDashboards'
import DefaultApp from './DefaultApp'
import AppsLayout from './AppsLayout'
import './style.scss'
import 'styles/app/apps/apps-layout.scss'

class Apps extends Component {
  componentDidUpdate(prevProps) {
    const {
      lastApplicationUrl,
      location: { pathname },
      applications,
      updateUserLastApplicationUrl,
    } = this.props

    if (
      checkPathInApps(pathname, applications) &&
      lastApplicationUrl === prevProps.lastApplicationUrl &&
      lastApplicationUrl !== pathname
    ) {
      withPromise(updateUserLastApplicationUrl, {
        lastApplicationUrl: pathname,
      }).then(errors => {
        if (errors) {
          return Promise.resolve(errors)
        }
      })
    }
  }

  applicationRoutes = applications =>
    applications.map(
      ({
        appUrl,
        appTitle,
        licenseeApplicationId,
        appId: applicationId,
        appName,
        isSisense,
        enableInUi,
      }) => {
        if (!enableInUi) {
          return (
            <Route key={appUrl} path={ROUTE.ERROR_404} component={Page404} />
          )
        }
        const sisenceCheck = isSisense ? SisenseDashboards : DefaultApp
        const AppComponent =
          APPLICATIONS[appTitle] !== undefined
            ? APPLICATIONS[appTitle]
            : sisenceCheck

        return (
          <Route
            key={appUrl}
            path={isSisense ? `${appUrl}/:slug?` : appUrl}
            render={props => (
              <AppComponent
                appUrl={appUrl}
                {...props}
                currentApp={{
                  id: licenseeApplicationId,
                  name: appName,
                  applicationId,
                }}
              />
            )}
          />
        )
      },
    )

  render() {
    const { applications } = this.props

    return (
      <Switch>
        {this.applicationRoutes(applications)}
        <Route
          path={ROUTE.APPS}
          component={() => <AppsLayout appList={applications} />}
        />
      </Switch>
    )
  }
}

const enhance = connect(
  state => ({
    applications: state.getIn(['profile', 'profile', 'applications']),
    lastApplicationUrl: state.getIn([
      'profile',
      'profile',
      'lastApplicationUrl',
    ]),
  }),
  {
    updateUserLastApplicationUrl,
  },
)

export default withRouter(enhance(Apps))
